<details *ngFor="let item of items"
         thema-core-expansion>
  <summary [ngClass]="summaryClasses">{{item.title}}</summary>
  <p [ngClass]="paragraphClasses">{{item.content}}</p>
</details>
